import {pageInfo, exportData, detail, listTitle} from './../api';
import {Message} from 'element-ui';

const systemLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null,
    detailObj: null,
    titleObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATE(state, data) {
      state.exportDataObj = data;
    },
    DETAIL(state, data) {
      state.detailObj = data.obj || {};
    },
    LIST_TITLE(state, data) {
      state.titleObj = data.obj || [];
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATE', resp);
    },
    async detail({commit}, obj) {
      let resp = await detail(obj);
      commit('DETAIL', resp);
    },
    async listTitle({commit}, obj) {
      let resp = await listTitle(obj);
      commit('LIST_TITLE', resp);
    },
  }
}
export default systemLog



// WEBPACK FOOTER //
// ./src/page/log/systemLog/store/systemLog.store.js